module.exports = __webpack_public_path__ + "img/myeduvisa-logo.8c9994bd.png";